'use strict';

var GridToolbarPrintButtonDirective = function GridToolbarPrintButtonDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/grid-toolbar-print-button.html')
  };
};
GridToolbarPrintButtonDirective.$inject = [];
module.exports = GridToolbarPrintButtonDirective;